import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "webins-widget-step-cols" }
const _hoisted_2 = { class: "availabilities-panel" }

import {} from "vue";
import { useI18n } from "vue-i18n";
import Loading from "../../loading.vue";
import SummaryRisultati from "../../summary-risultati.vue";
import Result from "./result.vue";
import { useNavigation, usePolizze } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { prev } = useNavigation();
const { loading } = usePolizze();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Result)
      ]),
      _createElementVNode("div", null, [
        _createVNode(SummaryRisultati)
      ])
    ]),
    _createVNode(Loading, { isloading: _unref(loading) }, null, 8, ["isloading"])
  ], 64))
}
}

})